import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [cart, setCart] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/cart");
      setCart(data);
    } catch {
      setCart(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const add = async (payload) => {
    const { data } = await api.post("/cart/add", payload);
    setCart(data);
    return data;
  };
  const update = async (index, quantity) => {
    const { data } = await api.post("/cart/update", { index, quantity });
    setCart(data);
  };
  const remove = async (index) => {
    const { data } = await api.post("/cart/remove", { index });
    setCart(data);
  };
  const clear = async () => {
    await api.post("/cart/clear");
    refresh();
  };

  const count = cart?.lines?.reduce((a, l) => a + l.quantity, 0) || 0;
  const subtotal = cart?.lines?.reduce((a, l) => a + l.unit_price * l.quantity, 0) || 0;

  return (
    <CartCtx.Provider value={{ cart, loading, refresh, add, update, remove, clear, count, subtotal }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
